import "./modulePreview.css";
import Patterns from "../summaryReport/subComponents/patterns";
import { roofStructureData } from "./structureFunction";

const StructurePreview = (props) => {
  const { roofDetail } = props;
  let structureItem = roofStructureData.find(
    (item) => item.name === roofDetail.mountingStructure
  );

  return (
    <>
      <div id="panel-datasheet" className="panel-datasheet">
        {/* Patterns */}
        <Patterns />
        <main className="pd-body">
          <img
            className="img"
            src={structureItem.structureDataSheet}
            alt={structureItem.name}
          ></img>
        </main>
      </div>
    </>
  );
};

export default StructurePreview;
